const KEY = "recentlyViewed";
const MAX_ITEMS = 10;

export const addRecentlyViewed = (item) => {
  if (!item?.product_id) return;
  try {
    const existing = JSON.parse(localStorage.getItem(KEY) || "[]");
    const filtered = existing.filter((p) => p.product_id !== item.product_id);
    const updated = [item, ...filtered].slice(0, MAX_ITEMS);
    localStorage.setItem(KEY, JSON.stringify(updated));
  } catch {}
};

export const getRecentlyViewed = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};
